import { Property } from "./property.model";

export class Basket {
  properties: Array<Property> = new Array<Property>();
}
